import { Injectable } from '@angular/core'
import { APIService } from 'api/module'
import { AssetMiniReference, MediaFileBundleMiniReference, SubtitleClipboardEntry } from 'elements-sdk/src'

@Injectable({ providedIn: 'root' })
export class SubtitlesClipboardService {
  items: SubtitleClipboardEntry[] = []
  loading = false

  constructor (
    private api: APIService,
  ) {
    this.reload()
  }

  async reload (): Promise<void> {
    this.loading = true
    this.items = await this.api.mediaLibrary.getAllSubtitleClipboardEntries({})
    this.loading = false
  }

  async add (subtitle: AssetMiniReference, bundle: MediaFileBundleMiniReference): Promise<void> {
    if (!this.items.some(x => x.subtitle.id === subtitle.id)) {
      const entry = await this.api.mediaLibrary.createSubtitleClipboardEntry({
        subtitleClipboardEntryUpdate: { subtitle, bundle },
      })
      this.items = [...this.items, entry]
    }
  }

  async remove (subtitle: AssetMiniReference): Promise<void> {
    this.items = this.items.filter(x => x.id !== subtitle.id)
    await this.api.mediaLibrary.deleteSubtitleClipboardEntry(subtitle)
  }

  async clear (): Promise<void> {
    this.items = []
    await this.api.mediaLibrary.clearSubtitleClipboard()
  }
}
